const React = require('react');
const PropTypes = require('prop-types');
const { useTranslation } = require('react-i18next');
const { MetaItem } = require('stremio/components');
const { default: getMetaDetailsHref } = require('stremio/common/getMetaDetailsHref');
const styles = require('./CarolineLibraryItem.less');

const CarolineLibraryItem = ({ reference, metadataStatus, metadata, removeItem }) => {
    const { t } = useTranslation();
    const optionOnSelect = React.useCallback((event) => {
        if (event.value === 'remove') {
            removeItem({ mediaType: reference.mediaType, metaId: reference.metaId }).catch(() => undefined);
        }
    }, [removeItem, reference.mediaType, reference.metaId]);
    const href = metadata?.deepLinks ? getMetaDetailsHref(metadata.deepLinks, true) : undefined;

    return (
        <div className={styles['item']}>
            <MetaItem
                type={metadata?.type || reference.mediaType}
                name={metadata?.name}
                poster={metadata?.poster}
                posterShape={metadata?.posterShape || 'poster'}
                href={href}
                options={[{ label: t('LIBRARY_REMOVE'), value: 'remove' }]}
                actionMenu={true}
                optionOnSelect={optionOnSelect}
            />
            {metadataStatus === 'unavailable' ? (
                <div className={styles['degraded-label']} title={`${reference.mediaType}: ${reference.metaId}`}>
                    {reference.mediaType}
                </div>
            ) : null}
        </div>
    );
};

CarolineLibraryItem.propTypes = {
    reference: PropTypes.shape({
        mediaType: PropTypes.string.isRequired,
        metaId: PropTypes.string.isRequired,
        addedAt: PropTypes.string.isRequired,
    }).isRequired,
    metadataStatus: PropTypes.oneOf(['loading', 'ready', 'unavailable']).isRequired,
    metadata: PropTypes.object,
    removeItem: PropTypes.func.isRequired,
};

module.exports = CarolineLibraryItem;
